// React
import { useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spinner } from 'reactstrap';

// Containers Injections & Components
import { ModalProposals } from '../../components/modalProposals';
import { ModalVerifyCpf } from '../../components/modalVerifyCpf';
import { AssociatesInjection } from '../../containers/associatesInjection';
import {
  CardsResume,
  FloatButton,
  SearchGroup,
  PageWrapper,
  DropdownDatatable,
} from '../../containers/componentsInjection';

const AssociatesScreen = () => {
  let savedSearch = JSON.parse(sessionStorage.getItem('searchGroup'));

  const [sort, setSort] = useState('asc');
  const [search, setSearch] = useState(savedSearch || '');
  const [perPage, setPerPage] = useState(10);
  const [columnSort, setColumnSort] = useState(1);
  const [currentPage, setCurrentPage] = useState(
    Number(sessionStorage.getItem('currentPageRemote'))
  );
  const [isOpenProposalsModal, setIsOpenProposalsModal] = useState(false);
  const [customerName, setCustomerName] = useState({});
  const [modalVerifyCpf, setModalVerifyCpf] = useState(false);

  const history = useHistory();

  const {
    total,
    today,
    active,
    success,
    loading,
    inactive,
    associates,
    deleteAssociate,
    getOrderAssociates,
    getSummaryAssociates,
    requestGetProposalsAssociates,
    proposalsAssociates,
  } = AssociatesInjection();

  function tog_modalProposals() {
    setIsOpenProposalsModal(!isOpenProposalsModal);
  }

  function tog_modalVerifyCpf() {
    setModalVerifyCpf(!modalVerifyCpf);
  }

  const handleDelete = (id) => {
    deleteAssociate(id);
  };

  const handleEdit = (values) => {
    const { hashid } = values;

    history.push(`/associados/edit/${hashid}`);
  };

  // Config for DataTable
  const handleChangeRowsPerPage = async (newPerPage, page) => {
    setPerPage(newPerPage);
    await getOrderAssociates({
      page: page,
      length: newPerPage,
      search: search,
      order_column: columnSort,
      order_dir: sort,
    });
  };

  const handleChangePage = async (page) => {
    setCurrentPage(page);
    sessionStorage.setItem('currentPageRemote', page);

    await getOrderAssociates({
      page: page,
      length: perPage,
      search: search,
      order_column: columnSort,
      order_dir: sort,
    });
  };

  const handleSort = async (column, sortDirection) => {
    setSort(sortDirection);
    setColumnSort(column.id - 1);
    await getOrderAssociates({
      page: 1,
      length: perPage,
      search: search,
      order_column: column.id - 1,
      order_dir: sortDirection,
    });
  };

  const handleSearch = async (event) => {
    setSearch(event);
    setCurrentPage(1);

    const obj = JSON.stringify(event);
    sessionStorage.setItem('searchGroup', obj);

    await getOrderAssociates({
      page: 1,
      length: perPage,
      search: event,
      order_column: 1,
      order_dir: 'asc',
    });
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      sortable: true,
      width: '30%',
      selector: (cell) => {
        return (
          <ul
            className="list-inline hstack gap-2 mb-0 "
            style={{
              width: '100%',
              display: 'flex',
              alignSelf: 'center',
            }}
          >
            <li className="list-inline-item" title="Remove">
              {cell.name}
            </li>
          </ul>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">CPF</span>,
      selector: (row) => row.cpf,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Telefone</span>,
      selector: (row) => row.phone1,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Cidade</span>,
      selector: (row) => row.city,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Situação</span>,
      sortable: false,
      width: '20%',
      selector: (cell) => {
        return (
          <div>
            {cell.tags.length > 0 &&
              cell.tags.map((item, index) => {
                return (
                  <span key={index} className={item.color}>
                    <i className="mdi mdi-circle-medium"></i> {item.title}
                  </span>
                );
              })}
          </div>
        );
      },
    },
  ];

  const infoWidgets = [
    {
      id: 1,
      label: 'Total de associados',
      badge: 'ri-arrow-right-up-line',
      badgeClass: 'success',
      percentage: '+16.24',
      counter: total,
      link: 'View net earnings',
      bgcolor: 'success',
      iconColor: '#19C28A',
      icon: 'bx bx-dollar-circle',
      decimals: 0,
      prefix: '',
      suffix: '',
    },
    {
      id: 2,
      label: 'Associados ativos',
      badge: 'ri-arrow-right-down-line',
      badgeClass: 'danger',
      percentage: '-3.57',
      counter: active,
      link: 'View all orders',
      bgcolor: 'info',
      iconColor: '#2D6E8F',
      icon: 'bx bx-shopping-bag',
      decimals: 0,
      prefix: '',
      suffix: '',
    },
    {
      id: 3,
      label: 'Associados Inativos',
      badge: 'ri-arrow-right-up-line',
      badgeClass: 'success',
      percentage: '+29.08',
      counter: inactive,
      link: 'See details',
      bgcolor: 'warning',
      iconColor: '#F6533E',
      icon: 'bx bx-user-circle',
      decimals: 0,
      prefix: '',
      suffix: '',
    },
    {
      id: 4,
      label: 'Cadastrados hoje',
      badgeClass: 'muted',
      percentage: '+0.00',
      counter: today,
      link: 'Withdraw money',
      bgcolor: 'danger',
      iconColor: '#F5D507',
      icon: 'bx bx-wallet',
      decimals: 0,
      prefix: '',
      suffix: '',
    },
  ];

  useEffect(() => {
    getSummaryAssociates();
    getOrderAssociates({
      page: currentPage || 1,
      length: perPage,
      search: search,
      order_column: 1,
      order_dir: 'asc',
    });
  }, []);

  return (
    <PageWrapper title={'Associados'}>
      <Row>
        <Col xs={12}>
          <Card>
            <div id="table-gridjs">
              <Col>
                <div className="h-100">
                  <CardsResume data={infoWidgets} />
                </div>
              </Col>

              <SearchGroup handleSearch={handleSearch} />

              <DropdownDatatable
                progressPending={loading}
                progressComponent={
                  <Spinner
                    type="grow"
                    style={{
                      margin: 25,
                    }}
                  />
                }
                columns={columns}
                loading={loading}
                data={associates ? associates.data : []}
                paginationServer
                pagination
                persistTableHead
                perPage={perPage}
                sortServer
                canSearch={false}
                onSort={handleSort}
                paginationTotalRows={associates ? associates.recordsTotal : 0}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                actions={[
                  {
                    id: 1,
                    name: 'edit',
                    label: 'Editar',
                    onPress: (cellProps) => handleEdit(cellProps),
                    icon: 'la-pen',
                    classNameColorIcon: 'primary',
                  },
                  {
                    id: 2,
                    name: 'proposals',
                    label: 'Propostas',
                    onPress: (cellProps) => {
                      setCustomerName(cellProps.name);
                      requestGetProposalsAssociates(
                        cellProps.hashid,
                        tog_modalProposals,
                        true
                      );
                    },
                    icon: 'la-file-invoice',
                    classNameColorIcon: 'info',
                  },
                ]}
                handleDelete={(cellProps) => handleDelete(cellProps)}
                isRemotePagination
                currentPageRemote={currentPage || 1}
                paginationDefaultPage={currentPage || 1}
              />
            </div>
          </Card>
        </Col>
      </Row>

      <FloatButton
        handleButton={() => {
          tog_modalVerifyCpf();
        }}
      />

      <ModalProposals
        toggle={tog_modalProposals}
        customerName={customerName}
        isOpen={isOpenProposalsModal}
        proposalsAssociates={proposalsAssociates || []}
      />

      <ModalVerifyCpf isOpen={modalVerifyCpf} toggle={tog_modalVerifyCpf} />
    </PageWrapper>
  );
};

export default AssociatesScreen;
